import { useContext } from 'react'
import { Toaster } from 'react-hot-toast'
import AllCommentsComponent from '../../components/allCommentsComponent/allCommentsComponent'
import FormComponent from '../../components/formComment/formComponent'
import LoadingCommentsComponent from '../../components/loadingCommentsComponent/loadingCommentsComponent'
import NavbarComponent from '../../components/navbarComponent/navbarComponent'
import { AllCommentsContext } from '../../context/allComentsContext'
import { ThemeContext } from '../../context/themeContext'
import styles from "./mainPageComponent.module.css"
const MainPageComponent = () => {
  const {actualTheme} = useContext(ThemeContext)
  const {commentsLoaded} = useContext(AllCommentsContext)
  return (
    <div style={{backgroundColor: actualTheme.mainPageBackgroundColor}}  className={`${styles.pageContainer}`}>
         <NavbarComponent/>
      <div className={`${styles.mainContainer}`}>
        <FormComponent />
        {
          commentsLoaded?
          <AllCommentsComponent />:
          <LoadingCommentsComponent/>
        }
      </div>
      <Toaster />
  
    </div>
  )

}

export default MainPageComponent